module.exports = __webpack_public_path__ + "static/media/sf_restaurant_14.f8b0b3e7.jpg";